import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Row, Col } from "react-bootstrap";
import { EXPLOER, trimAddress } from '../helper/constant';
import { useAccount } from 'wagmi';




export default function Referral({ accStats }) {
    const { address } = useAccount();

    const [referrallink, setReferrallink] = useState(
        "Please connect your wallet"
    );
    const [refcopy, setRefcopy] = useState(false);
    const [addrcopy, setAddrcopy] = useState(false);
    let base_url = `${window.location.origin}/staking?ref=`;

    useEffect(() => {
        if (address) {
            setReferrallink(`${base_url}${address}`);
        } else {
            setReferrallink("Please connect your wallet");
        }
    }, [address, base_url]);

    return (
        <>
            <div className='ref-main text-center'>
                <article className="presentation">
                    <h2 className="page-title text-white">Refer Friends. Earn Crypto Together.</h2>
                    <p className="description">Earn up to 10% commission on every earn.</p>
                </article>
                <div className="input-group mx-3 my-3 d-flex justify-content-center">
                    <input type="text" className="ref-input" value={referrallink} readOnly={true} />
                    <span className="input-group-text" id="basic-addon2">

                        <CopyToClipboard text={`${base_url}${address}`} onCopy={() => {
                            setRefcopy(true);
                            setTimeout(() => {
                                setRefcopy(false);
                            }, 2000)
                        }}>
                            <button className="button" type="button">
                                <img src="https://s2.svgbox.net/octicons.svg?ic=copy" alt="Icon" />
                            </button>
                        </CopyToClipboard>
                        <span>{refcopy && 'copied'}</span>
                    </span>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="ref-per bd-highlight level-span">Level 1 &nbsp; :&nbsp;  10%</div>
                    <div className="ref-per bd-highlight level-span">Level 2 &nbsp; :&nbsp;  7%</div>
                    <div className="ref-per bd-highlight level-span">Level 3 &nbsp; :&nbsp;  5%</div>
                    <div className="ref-per bd-highlight level-span">Level 4 &nbsp; :&nbsp;  2%</div>
                    <div className="ref-per bd-highlight level-span">Level 5 &nbsp; :&nbsp;  0.5%</div>
                    <div className="ref-per bd-highlight level-span">Level 6 &nbsp; :&nbsp;  0.5%</div>
                </div>
                {/* <div className="d-flex justify-content-around">
                <div className="p-2 bd-highlight level-span mt-3">Your Referral Earning : {refStats.rewardRef ? formatPrice(refStats.rewardRef) : 0} DC</div>
                <div className="p-2 bd-highlight level-span mt-3">Your Referral Count : {refStats.countRef ? refStats.countRef : 0} </div>
            </div> */}
            </div>
            <div className='container dw-container'>
                <Row>

                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 1</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {accStats.team0 ? parseInt(accStats.team0 , 0) : 0 }</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accStats && accStats.userReferral0 && accStats.userReferral0.length > 0 ? (
                                        accStats.userReferral0.map((value, index) => {
                                            return (
                                                <tr>
                                                    <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                    <td>{value[2] / Math.pow(10, accStats.tokenDecimals ? accStats.tokenDecimals : 0)} {accStats.tokenSymbol ? accStats.tokenSymbol : 0}</td>
                                                </tr>
                                            )
                                        })

                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 2</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {accStats.team1 ? parseInt(accStats.team1, 0) : 0 }</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accStats && accStats.userReferral1 && accStats.userReferral1.length > 0 ? (
                                        accStats.userReferral1.map((value, index) => {
                                            return (
                                                <tr>
                                                    <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                    <td>{value[2] / Math.pow(10, accStats.tokenDecimals ? accStats.tokenDecimals : 0)} {accStats.tokenSymbol ? accStats.tokenSymbol : 0}</td>
                                                </tr>
                                            )
                                        })

                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 3</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {accStats.team2 ? parseInt(accStats.team2, 0) : 0 }</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accStats && accStats.userReferral2 && accStats.userReferral2.length > 0 ? (
                                        accStats.userReferral2.map((value, index) => {
                                            return (
                                                <tr>
                                                    <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                    <td>{value[2] / Math.pow(10, accStats.tokenDecimals ? accStats.tokenDecimals : 0)} {accStats.tokenSymbol ? accStats.tokenSymbol : 0}</td>
                                                </tr>
                                            )
                                        })

                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 4</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {accStats.team3 ? parseInt(accStats.team3, 0) : 0 }</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accStats && accStats.userReferral3 && accStats.userReferral3.length > 0 ? (
                                        accStats.userReferral3.map((value, index) => {
                                            return (
                                                <tr>
                                                    <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                    <td>{value[2] / Math.pow(10, accStats.tokenDecimals ? accStats.tokenDecimals : 0)} {accStats.tokenSymbol ? accStats.tokenSymbol : 0}</td>
                                                </tr>
                                            )
                                        })

                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 5</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {accStats.team4 ? parseInt(accStats.team4 , 0) : 0 }</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accStats && accStats.userReferral4 && accStats.userReferral4.length > 0 ? (
                                        accStats.userReferral4.map((value, index) => {
                                            return (
                                                <tr>
                                                    <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                    <td>{value[2] / Math.pow(10, accStats.tokenDecimals ? accStats.tokenDecimals : 0)} {accStats.tokenSymbol ? accStats.tokenSymbol : 0}</td>
                                                </tr>
                                            )
                                        })

                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={4}>
                        <h5 class="pt-3 highlight-span text-center">Your Referral Level : 6</h5>
                        <h5 class="py-1 highlight-span text-center">Total : {accStats.team5 ? parseInt(accStats.team5, 0) : 0 }</h5>
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="table-head text-white">
                                    <tr>
                                        <th scope="col">User Address</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accStats && accStats.userReferral5 && accStats.userReferral5.length > 0 ? (
                                        accStats.userReferral5.map((value, index) => {
                                            return (
                                                <tr>
                                                    <td><a className='text-white' href={`${EXPLOER}address/${value[0]}`} target='_blank' rel="noreferrer">{trimAddress(value[0])}</a></td>
                                                    <td>{value[2] / Math.pow(10, accStats.tokenDecimals ? accStats.tokenDecimals : 0)} {accStats.tokenSymbol ? accStats.tokenSymbol : 0}</td>
                                                </tr>
                                            )
                                        })

                                    ) : (
                                        <tr>
                                            <td colSpan={2}>No Record Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className='ref-main text-center dw-container'>
                <article className="presentation">
                    <h2 className="page-title text-white">Future Coin (FTC) Token Contract BSC</h2>
                </article>
                <div className="input-group mx-3 my-3 d-flex justify-content-center">
                    <input type="text" className="ref-input text-center" value="0x24b045bcb46dc84818ea98b0d6540049b313dffa" readOnly={true} />
                    <span className="input-group-text" id="basic-addon2">

                        <CopyToClipboard text={`0x24b045bcb46dc84818ea98b0d6540049b313dffa`} onCopy={() => {
                            setAddrcopy(true);
                            setTimeout(() => {
                                setAddrcopy(false);
                            }, 2000)
                        }}>
                            <button className="button" type="button">
                                <img src="https://s2.svgbox.net/octicons.svg?ic=copy" alt="Icon" />
                            </button>
                        </CopyToClipboard>
                        <span>{addrcopy && 'copied'}</span>
                    </span>
                </div>
            </div>
        </>
    )
}
